// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_ProfessionModel from '../../model/tdg-profession-model';
import Tdg_ProfessionDTO from '../dto/tdg-profession-dto';
import dtoSchema from '../schemas/tdg-profession-schema';

export default abstract class Tdg_ProfessionModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_ProfessionDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.creatorId = data.creatorId;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modified = data.modified ?? undefined;
      this.name = data.name ?? undefined;
      this.categoryId = data.categoryId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  name?: string;
  /**
  * @type {int64}
  */
  categoryId?: number;

  static toModel(dto: DeepPartial<Tdg_ProfessionDTO>): Tdg_ProfessionModel;
  static toModel(dto: DeepPartial<Tdg_ProfessionDTO> | undefined | null): Tdg_ProfessionModel | undefined;
  static toModel(dto: DeepPartial<Tdg_ProfessionDTO> | undefined | null): Tdg_ProfessionModel | undefined {
    return dto ? new Tdg_ProfessionModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_ProfessionModel> | Tdg_ProfessionModel): Tdg_ProfessionDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      creatorId: unwrapped.creatorId,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modified: unwrapped.modified,
      name: unwrapped.name,
      categoryId: unwrapped.categoryId,
    } as Tdg_ProfessionDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_ProfessionModel, can not map to Tdg_ProfessionDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
